<template>
  <!-- Сделать индикатор загрузки -->
  <v-container fluid>
    <v-row justify="center">
      <v-col
          cols="12"
          md="8"
          lg="6"
          xl="6"
          class="text-center">
        <v-card class="elevation-12" max-width="600">
          <v-toolbar :dark="$vuetify.theme.dark" color="primary">
            <v-toolbar-title>
              {{ $t('Рассылка сообщений') }}
            </v-toolbar-title>
          </v-toolbar>
          <v-progress-linear :height="10" :active="isLoading" color="loader" indeterminate />
          <v-alert
              class="text-center ma-1"
              outlined
              :value="success"
              type="success">
            {{ $t('Сообщение отправлено') }}
          </v-alert>
          <general-error v-if="!!generalError" />
          <v-card-text>
            <ValidationObserver ref="mailing">
              <validatable-text-input
                  v-model="subject"
                  rules="required"
                  :label="$t('Тема рассылки')" />
              <validatable-textarea
                  v-model="message"
                  :rules="{ required: true,
                            max: 4000 }"
                  rows="5"
                  :label="$t('Текст рассылки')" />

              <validatable-invited-organizations
                  v-model="participants"
                  v-test="{ combobox: 'participants' }"
                  :label="$t('Список организаций получателей')"
                  :search-label="$t('Выбор организации')"
                  rules="required"
                  :params="organizationsParams" />
            </ValidationObserver>
            <v-col
                cols="12"
                md="10"
                lg="10"
                xl="10"
                class="mt-3">
              <multiple-file-input
                  v-model="files"
                  :label="`${$t('Вложения')}:`" />
            </v-col>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
                id="sendBtn"
                v-test="{ btn: 'send' }"
                color="primary"
                :disabled="isLoading || !isAdmin"
                @click.stop="sendMail">
              {{ $t('Отправить') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import MultipleFileInput from '@/components/reused/ui/MultipleFileInput.vue'
  import ValidatableTextarea from '@/components/reused/ui/ValidatableTextarea.vue'
  import ValidatableTextInput from '@/components/reused/ui/ValidatableTextInput.vue'
  import ValidatableInvitedOrganizations from '@/components/reused/ui/ValidatableInvitedOrganizations.vue'
  import { PARTICIPANT_TYPES } from '@/constants/business'
  import { mapActions } from 'vuex'
  import { MAILING } from '@/constants/store.js'

  export default {
    components: {
      GeneralError,
      ValidatableTextarea,
      ValidatableTextInput,
      MultipleFileInput,
      ValidatableInvitedOrganizations
    },
    data () {
      return {
        isLoading: false,
        success: false,
        subject: null,
        message: null,
        files: [],
        participants: [],
        organizationsParams: {
          participantType: PARTICIPANT_TYPES.ORGPART
        }
      }
    },
    methods: {
      ...mapActions(MAILING.NAMESPACE, {
        sendParticipantsMailingAction: MAILING.ACTIONS.SEND_PARTICIPANTS_MAILING
      }),
      sendMail: async function () {
        this.hideErrorAction()
        const result = await this.$refs.mailing.validate()
        if (!result) {
          return
        }
        const model = this.getMessageModel()

        this.isLoading = true
        this.success = false
        try {
          await this.sendParticipantsMailingAction(model)
          this.isLoading = false
          this.success = true
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      getMessageModel: function () {
        const model = new FormData()

        this.files.forEach(file => {
          model.append('files', file.file, file.name)
        })

        model.append('subject', this.subject)
        model.append('message', this.message)

        for (var i = 0; i < this.participants.length; i++) {
          model.append('participants[]', this.participants[i])
        }

        return model
      }
    }
  }
</script>
